'use strict';

const $ = require('jquery');

class GoogleMap {

    constructor () {

        const $contactMap = $('[data-google-map="contact"]');

        if ($contactMap.length > 0) {

            require('../lib/google-map');

            $contactMap.customGoogleMap({
                map: {
                    draggable: true,
                    zoom: 6,
                    initialZoom: true,
                    zoomControl: false
                }
            });

        }

    }

}

module.exports = GoogleMap;
